module.exports = __webpack_public_path__ + "static/media/logo.b8958e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 821
// module chunks = 0